import type { VoidFunctionComponent } from 'react';
import { SearchInput } from '../../../../generic/Forms';
import styles from './ReleaseSelector.module.less';

type Props = {
  search: string;
  onChange: (value: string) => void;
};

/**
 * ReleaseGroupsReleaseSelectorHeader holds the search input.
 */
const ReleaseGroupsReleaseSelectorHeader: VoidFunctionComponent<Props> = ({ search, onChange }) => (
  <header className={styles.header}>
    <SearchInput
      label="Search releases"
      placeholder="Search releases"
      size="small"
      value={search}
      onChange={onChange}
    />
  </header>
);

export default ReleaseGroupsReleaseSelectorHeader;
